import { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import EventList from "../../features/Events/components/EventList";
import EventPagination from "../../features/Events/components/EventPagination";
import useEvent from "#features/Events/hooks/useEvent";

const EventsPage = () => {
  const HEADER_HEIGHT = 72;
  const isDirectAccess = window.history.length <= 2;
  const [currentIndex, setCurrentIndex] = useState(0);

  const { eventList } = useEvent();
  return (
    <section className="p-hasHeader">
      <Header title="전단광고" isDirectAccess={isDirectAccess} />

      <EventList items={eventList} HEADER_HEIGHT={HEADER_HEIGHT} />
      <EventPagination
        items={eventList}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        HEADER_HEIGHT={HEADER_HEIGHT}
      />
    </section>
  );
};

export default EventsPage;
